import { apiGet, apiPost } from '../../utilities/apiClient';
import { getSessionIds } from './_sessionIds';

type LocationPayload = {
  latitude: number;
  longitude: number;
  accuracy?: number | null;
  altitude?: number | null;
  heading?: number | null;
  speed?: number | null;
  timestamp: string;
  source?: string;
};


export const syncLocationData = (
  projectId: number | string,
  location: LocationPayload,
) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiPost(`/location/sync/${projectId}/${accountId}/${cognitoId}`, { location });
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const fetchLocationData = (projectId: number | string) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiGet(`/location/data/${projectId}/${accountId}/${cognitoId}`);
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};
